const controlTool = (el, control, controlList) => {
  if (controlList && !controlList.includes(control)) {
    el.parentNode && el.parentNode.removeChild(el) // 关键代码, 没有权限则删除元素
  }
}

export default {
  mounted(el, binding) {
    controlTool(el, binding.value)
  },
  updated(el, binding) {
    controlTool(el, binding.value)
  },
}
